import Generic from '@luketclancy/otterly/units/generic'

// Object.defineProperties(Generic, {
// 	el: {
// 		get: function(){return this.element},
// 		set: function(v){return this.element = v}
// 	}
// })
export default Generic